import styles from './Image.module.css';

import type { FC, ReactNode } from 'react';

import classNames from 'classnames';
import React, { memo, useState } from 'react';

import currencyImage from 'src/assets/images/currency.png';

import { Stack } from 'src/components/themed/Stack';

type ImageProps = {
  size?: 'small' | 'medium' | 'large';
  src?: string;
  icon?: ReactNode;
  className?: string;
  /**
   * What the picture is (a partner's name, the logo's owner). Omit it — or pass `''` — only for a
   * purely decorative picture, so a screen reader skips it instead of hearing the one word "Image"
   * that every `<img>` used to say (BUG-18).
   */
  alt?: string;
};

export const Image: FC<ImageProps> = memo((props) => {
  const { size = 'large', src, icon, className, alt = '' } = props;
  const [error, setError] = useState(false);

  return (
    <Stack
      className={classNames(styles.container, styles[`container-${size}`], className)}
      justifyContent="center"
      alignItems="center"
    >
      {src ? (
        <img
          // The placeholder that replaces a broken picture is not the thing the caller named.
          alt={error ? '' : alt}
          className={classNames(styles.image, styles[`image-${size}`])}
          src={error ? currencyImage : src}
          onError={() => setError(true)}
        />
      ) : null}
      {icon ? icon : null}
    </Stack>
  );
});
